/** FRONT-2669 — the Changes view's wording, pure so both states are pinned by tests. */
export const TOO_MANY_CHANGES = 'Too many changes to show here.';

/**
 * The line above the diff. `laterEdits` (the route's flag) means the before/after
 * pair spans more than Eddy's last edit, so the heading must not claim otherwise.
 * A missing flag is false.
 */
export function changesHeader(when: string | null, laterEdits: boolean): string {
  const lead = laterEdits ? "What changed since before EDDY's last edit, including later edits" : "What EDDY's last edit changed";
  return when ? `${lead} \u00B7 ${when}` : lead;
}
